export const ROW_PER_PAGE = 10;
export const PAGE_NUMBER = 0;
export const countryCodes = [
  {
    name: 'Bangladesh',
    code: '+880',
    label: 'BD',
  },
  {
    name: 'Brazil',
    code: '+55',
    label: 'BR',
  },
  {
    name: 'China',
    code: '+86',
    label: 'CN',
  },
  {
    name: 'Egypt',
    code: '+20',
    label: 'EG',
  },
  {
    name: 'Ethiopia',
    code: '+251',
    label: 'ET',
  },
  {
    name: 'Germany',
    code: '+49',
    label: 'DE',
  },
  {
    name: 'India',
    code: '+91',
    label: 'IN',
  },
  {
    name: 'Indonesia',
    code: '+62',
    label: 'ID',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    code: '+98',
    label: 'IR',
  },
  {
    name: 'Japan',
    code: '+81',
    label: 'JP',
  },
  {
    name: 'Mexico',
    code: '+52',
    label: 'MX',
  },
  {
    name: 'Nigeria',
    code: '+234',
    label: 'NG',
  },
  {
    name: 'Pakistan',
    code: '+92',
    label: 'PK',
  },
  {
    name: 'Philippines',
    code: '+63',
    label: 'PH',
  },
  {
    name: 'Russia',
    code: '+7',
    label: 'RU',
  },
  {
    name: 'Thailand',
    code: '+66',
    label: 'TH',
  },
  {
    name: 'Turkey',
    code: '+90',
    label: 'TR',
  },
  {
    name: 'United States',
    code: '+1',
    label: 'US',
  },
  {
    name: 'United Kingdom',
    code: '+44',
    label: 'UK',
  },
  {
    name: 'Vietnam',
    code: '+84',
    label: 'VN',
  },
];

export const grantTypes = [
  {
    id: 'authorization_code',
    name: 'Code',
    text: 'Code',
  },
  { id: 'client_credentials', name: 'Client Credentials', text: 'Client Credentials' },
  {
    id: 'password',
    name: 'Password',
    text: 'Password',
  },
  {
    id: 'refresh_token',
    name: 'Refresh Token',
    text: 'Refresh Token',
  },
  { id: 'saml2', name: 'SAML2', text: 'SAML2' },
];
